export const getCurrentPageItems = (items: any[], page: number, size: number) => {
  const lastCardIndex = page * size;
  const firstCardIndex = lastCardIndex - size;
  return items.slice(firstCardIndex, lastCardIndex);
};
